import React from 'react';

// node-cron uses 0 = Sunday through 6 = Saturday.
const DAYS = [
  { value: 1, short: 'Mon', label: 'Monday' },
  { value: 2, short: 'Tue', label: 'Tuesday' },
  { value: 3, short: 'Wed', label: 'Wednesday' },
  { value: 4, short: 'Thu', label: 'Thursday' },
  { value: 5, short: 'Fri', label: 'Friday' },
  { value: 6, short: 'Sat', label: 'Saturday' },
  { value: 0, short: 'Sun', label: 'Sunday' },
];

const TIMEZONES = [
  'Europe/Ljubljana',
  'Europe/Vienna',
  'Europe/Berlin',
  'Europe/Zagreb',
  'Europe/London',
  'UTC',
];

export default function ScheduleConfig({ schedule, onChange }) {
  const s = schedule || {};
  const days = Array.isArray(s.days) ? s.days : [];

  const update = (patch) => onChange({ ...s, ...patch });

  const toggleDay = (value) => {
    const next = days.includes(value)
      ? days.filter((d) => d !== value)
      : [...days, value].sort((a, b) => a - b);
    update({ days: next });
  };

  return (
    <div className="schedule-config">
      <div className="schedule-row">
        <label className="schedule-field">
          <span>Time</span>
          <input
            type="time"
            value={s.time || '09:00'}
            onChange={(e) => update({ time: e.target.value })}
            disabled={s.enabled === false}
          />
        </label>

        <label className="schedule-field">
          <span>Timezone</span>
          <select
            value={s.timezone || 'Europe/Ljubljana'}
            onChange={(e) => update({ timezone: e.target.value })}
            disabled={s.enabled === false}
          >
            {TIMEZONES.map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
        </label>

        <label className="schedule-field enabled-field">
          <span>Enabled</span>
          <div className="toggle">
            <input
              type="checkbox"
              checked={s.enabled !== false}
              onChange={(e) => update({ enabled: e.target.checked })}
            />
            <span className="slider" />
          </div>
        </label>
      </div>

      <div className="schedule-days">
        <span className="schedule-days-label">Run on</span>
        <div className="day-chips">
          {DAYS.map((d) => {
            const active = days.includes(d.value);
            return (
              <button
                key={d.value}
                type="button"
                title={d.label}
                className={`day-chip ${active ? 'active' : ''}`}
                onClick={() => toggleDay(d.value)}
                disabled={s.enabled === false}
              >
                {d.short}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
